module.exports = __webpack_public_path__ + "static/img/basket.9097acbd.svg";